import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import {
  selectAllEntities,
  setEntities,
  upsertEntities,
  withEntities,
} from '@ngneat/elf-entities';
import { Observable } from 'rxjs';
import { v4 as createUuid } from 'uuid';

export interface NotificationItem {
  id: string;
  dateCreated: string;
  textMessage: string;
  isRead: boolean;
  link?: string;
}

export type NotificationEntity = NotificationItem;

@Injectable({
  providedIn: 'root',
})
export class NotificationsRepository {
  public store = createStore(
    { name: 'notifications' },
    withEntities<NotificationEntity>(),
    withProps<NotificationEntity[]>(undefined as unknown as NotificationItem[])
  );

  public state$: Observable<NotificationEntity[]> = this.store.pipe(
    selectAllEntities()
  );

  public set(entities: NotificationEntity[]): void {
    this.store.update(setEntities(entities));
  }

  public upsert(entities: NotificationEntity[]): void {
    this.store.update(upsertEntities(entities));
  }

  public reset(): void {
    this.store.reset();
  }

  // Entity Stores require a unique ID for each entity. This function creates a UUID for each entity.
  public createEntities(entities: NotificationItem[]): NotificationEntity[] {
    const newEntities: NotificationEntity[] = [];

    for (const entity of entities) {
      newEntities.push({
        ...entity,
        id: entity.id ? entity.id : createUuid(),
      });
    }

    return newEntities;
  }
}
